module.exports = __webpack_public_path__ + "img/dianjiyun8.d3a9ab90.png";